import React from 'react';
import Skeleton from 'react-loading-skeleton';

const NewCrossBorderReceiverSkeleton = (): JSX.Element => (
    <div className="cross-border-payment__new-receiver-skeleton">
        <Skeleton className="new-receiver-skeleton__title" height={20} width="15%" />
        <Skeleton className="new-receiver-skeleton__input" height={45} />
    </div>
);

export default NewCrossBorderReceiverSkeleton;
